import { SB_MINT_ADDRESS } from "../../utils/ids";

export const tokensData = [
    { name: "custom", address:"", symbol: "Custom Token", decimals: 0},
    { name: "RZR", address: SB_MINT_ADDRESS, symbol: "RZR", decimals: 8},
    { name: "solETH", address: "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs", symbol: "solETH", decimals: 6},
    { name: "solBTC", address: "3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh", symbol: "solBTC", decimals: 6},
    { name: "RAY", address: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R", symbol: "RAY", decimals: 6},
];